// services/userClientAuthorizationService.ts
import axios from 'axios';
import config from '../config';

export interface UserClientAuthorization {
  id: string;
  user_id: string;
  client_id: string;
  permission: boolean;
  active: boolean;
  created_at: string;
  updated_at: string;
}

export interface CreateUserClientAuthorizationRequest {
  user_id: string;
  client_id: string;
  permission: boolean;
  active?: boolean;
}

export interface UpdateUserClientAuthorizationRequest {
  permission: boolean;
  active?: boolean;
}

class UserClientAuthorizationService {
  private getAuthHeaders() {
    const user = JSON.parse(localStorage.getItem('auth_user') || '{}');
    if (!user?.accessToken) {
      throw new Error('User not authenticated');
    }
    
    return {
      Authorization: `${user.tokenType.charAt(0).toUpperCase()}${user.tokenType.slice(1)} ${user.accessToken}`
    };
  }

  async getAuthorizationByUserAndClient(userId: string, clientId: string): Promise<UserClientAuthorization | null> {
    try {
      const { data } = await axios.get<UserClientAuthorization>(
        `${config.API_BASE_URL}/api/user-client-authorization/user/${userId}/client/${clientId}`,
        { headers: this.getAuthHeaders() }
      );
      return data;
    } catch (error: any) {
      if (error.response?.status === 404) {
        return null; // No authorization found
      }
      throw error;
    }
  }

  async createAuthorization(request: CreateUserClientAuthorizationRequest): Promise<UserClientAuthorization> {
    const { data } = await axios.post<UserClientAuthorization>(
      `${config.API_BASE_URL}/api/user-client-authorization`,
      request,
      { headers: this.getAuthHeaders() }
    );
    return data;
  }

  async updateAuthorization(authorizationId: string, request: UpdateUserClientAuthorizationRequest): Promise<UserClientAuthorization> {
    const { data } = await axios.patch<UserClientAuthorization>(
      `${config.API_BASE_URL}/api/user-client-authorization/${authorizationId}`,
      request,
      { headers: this.getAuthHeaders() }
    );
    return data;
  }

  async deleteAuthorization(authorizationId: string): Promise<void> {
    await axios.delete(
      `${config.API_BASE_URL}/api/user-client-authorization/${authorizationId}`,
      { headers: this.getAuthHeaders() }
    );
  }
}

export const userClientAuthorizationService = new UserClientAuthorizationService();
